import GetStartedCorporate from "../screen/container/get-started/corporate/get-started-corporate";

export const routesCorporate = [
    {
        path: "/get-started-corporate",
        exact: true,
        component: GetStartedCorporate,
        guard: "public",
    },
];